import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function LoadingPage() {
    return (
        <div className="my-auto mx-auto">LOADING <FontAwesomeIcon icon="fas fa-spinner" pulse /></div>
        )
}